<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Reporte TxPxa</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>RP_tx_px_a</div>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col>
              <b-form-group align="left">
                <label>Clínicas</label>
                <v-select
                  v-if="!todas"
                  name="clinica"
                  placeholder="Clinicas"
                  label="strNombre"
                  multiple
                  :reduce="(variable) => variable.idClinica"
                  :options="clinicas"
                  v-model="filtro.idClinicas"
                ></v-select>
                <br />
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="todas"
                  name="checkbox-1"
                  @change="todos()"
                >
                  Todas las clínicas
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label>Fecha de inicio</label>
                <b-input-group size="sm" class="mb-2" id="fci" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Inicio"
                    :max="new Date()"
                    v-model="$v.filtro.fechaInicio.$model"
                    :state="validateState('fechaInicio')"
                    labelNoDateSelected="Fecha"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group align="left">
                <label>Fecha de fin</label>
                <b-input-group size="sm" class="mb-2" id="fcf" lab>
                  <b-form-datepicker
                    name="nombre"
                    placeholder="Fecha de Fin"
                    :min="filtro.fechaInicio"
                    :max="new Date()"
                    v-model="$v.filtro.fechaFin.$model"
                    :state="validateState('fechaFin')"
                    labelNoDateSelected="Fecha"
                  ></b-form-datepicker>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col></b-col>
            <b-col class="text-right">
              <b-button
                variant="outline-primary"
                :disabled="loader"
                @click="obtenerDatos()"
              >
                <span v-if="!loader">Buscar</span>
                <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { required } from "vuelidate/lib/validators";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  components: {
    Header,
  },
  name: "ReporteTxPxa",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loader: false,
      buscado: false,
      show: false,
      filtro: {
        idClinicas: [],
        fechaInicio: null,
        fechaFin: null,
      },

      clinicas: [],
      todas: false
    };
  },
  validations: {
    filtro: {
      fechaInicio: { required },
      fechaFin: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerClinicas();
    this.filtro.idClinicas = [this.$localStorageService.getIdClinica()];
    this.filtro.fechaInicio = this.$moment().startOf('day').toDate();
    this.filtro.fechaFin = this.$moment().endOf('day').toDate();
  },
  methods: {
    obtenerClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.clinicas = respuesta.data.data;
          }
        });
    },
    obtenerDatos() {
      this.$v.filtro.$touch();

      if (!this.todas && this.filtro.idClinicas.length == 0) {
        this.$swal({
          icon: "error",
          text: "Debe seleccionar al menos una clínica para realizar la búsqueda",
        });
      } else {
        if (!this.$v.filtro.$invalid) {
          this.loader = true;
          this.buscado = false;

          const envio = {
            idClinicas: this.todas ? [-1] : this.filtro.idClinicas,
            fechaInicio: this.$moment(this.filtro.fechaInicio)
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            fechaFin: this.$moment(this.filtro.fechaFin)
              .add(1, "days")
              .utc()
              .format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
            horas: this.$horas(),
          };

          this.$http
            .post(this.$api + "finanzas/reporte/txPxa", envio)
            .then((respuesta) => {
              this.saveXLSX( respuesta.data.data)
            })
            .finally(() => {
              this.loader = false;
              this.buscado = true;
              // this.datosTabla = this.datosTabla.map((it) => {
              //   return {
              //     "Mes num": this.obtenerDato(it.mes),
              //     Mes: moment()
              //       .month(it.mes - 1)
              //       .format("MMMM"),
              //     "Fecha Sesión": moment(it.fechaSesion).format("DD/MM/YYYY"),
              //     "Sesión Inicio": moment(it.sesionInicio).format("hh:mm:ss A"),
              //     "Sesión Fin": moment(it.sesionFin).format("hh:mm:ss A"),
              //     "Sesión Duración": this.obtenerDato(it.sesionDuracion),
              //     "Sesión Segundos": this.obtenerDato(it.sesionSegundos),
              //     "Tipo de Paciente": this.obtenerDato(it.tipoPaciente),
              //     "Subtipo de Paciente": this.obtenerDato(it.subtipoPaciente),
              //     idPaciente: this.obtenerDato(it.idPaciente),
              //     Paciente: this.obtenerDato(it.paciente),
              //     "¿Como te enteraste?": this.obtenerDato(it.comoSeEntero),
              //     "Motivo de pago": this.obtenerDato(it.motivoPago),
              //     "Forma de pago": this.obtenerDato(it.formaPago),
              //     "Precio por sesión": this.$formatoMoneda(it.precioPorSesion),
              //     descuentoPlan: this.obtenerDato(it.descuentoPlan, true) + "%",
              //     ingresoSinTraspaso: this.$formatoMoneda(it.ingresoSinTraspaso),
              //     traspaso: this.$formatoMoneda(it.traspaso),
              //     ingresoConTraspaso: this.$formatoMoneda(it.ingresoConTraspaso),
              //     "Sesión número": this.obtenerDato(it.sessNum),
              //     "Total sesiones": this.obtenerDato(it.sessFrom),
              //     idTratamiento: this.obtenerDato(it.idTratamiento),
              //     Tratamiento: this.obtenerDato(it.nombreTratamiento),
              //     Diente: this.obtenerDato(it.diente) != 0 ? this.obtenerDato(it.diente) : "-",
              //     "Especialidades Tratamiento": this.obtenerDato(it.especialidades),
              //     "Puestos Doctor": this.obtenerDato(it.especialidadesEmpleado),
              //     idDoctor: this.obtenerDato(it.idDoctor),
              //     Doctor: this.obtenerDato(it.doctor),
              //     "Doctor Cabecera": this.obtenerDato(it.doctorCabecera),
              //     "Id Clínica": this.obtenerDato(it.idClinica),
              //     Clínica: this.obtenerDato(it.nombreClinica),
              //     Región: this.obtenerDato(it.clinicaZona),
              //     "Plan Dental/Convenio": this.obtenerDato(it.planConvenio),
              //     Cuenta: this.obtenerDato(it.empresa),
              //     "Grupo Empresa": this.obtenerDato(it.grupoEmpresa),
              //
              //     /*
              //         ??  mesPeriodo
              //       */
              //   };
              // });
            });
        }
      }
    },
    saveXLSX(datos) {
      const zip = new JSZip();
      zip.file("TXPXPA.xlsx", datos, { base64: true });
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, "txpxpa.zip");
      });
    },
    todos() {
      this.todas = !this.todas;
      this.filtro.idClinicas = [];
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>

<style scoped>
.adquisicionSpan {
  cursor: pointer;
  text-decoration: underline;
  color: #00458b;
}

.badgeCss {
  display: flex;
  justify-content: flex-end;
}

.badgeTxt {
  padding: 10px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: lighter;
}
</style>
